import { render, staticRenderFns } from "./VisitProjectCard.vue?vue&type=template&id=49a5e3fd"
import script from "./VisitProjectCard.vue?vue&type=script&lang=js"
export * from "./VisitProjectCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports